
// TODO predelat selectory, at jsou hlavne i pro registracni formular a univerzalne
const ICOfield = $("[data-cis='ares-validation']");
const button_ares = '<button id="validateAres" class="c-btn c-btn--primary">Vyplnit z ARES</button>';
const labelAres = $("label[for$='identification_number']");
let jmeno = $('[id$="invoicing_address_name"]')
if(!jmeno.length){
    jmeno = $('[id$="company"]');
}
const ulice = $('[id$="invoicing_address_street"]');
const mesto = $('[id$="invoicing_address_city"]');
const psc = $('[id$="invoicing_address_zipcode"]');
const dic = $('[id$="tax_identity"]');

// checkeneme, jestli je valdiace zapnuta - podle data-cis atributu v ICO fieldu
if (ICOfield.length) {

    // vytvorim button an validaci, zakladne skryty
    labelAres.parent().append(button_ares);


// odstranim mezery z IC
    ICOfield.on('change keypress', function (e) {
        $(this).val($(this).val().trim().replace(/\s+/g, ''));
    });

}
//zobrazim pokud mam hodnotu, pokud ne zase skryju
ICOfield.on('change keypress', function (e) {
    if (ICOfield.val().length > 0) {

        //pridam nebo odeberu tlacitko ares, pokdu mam neco v ico fieldu
        $('#validateAres').show();
    } else {
        $('#validateAres').hide();
    }
});


//overeni IC ares
$(document).on("click", "#validateAres", function (e) {
    e.preventDefault();

    const ico_ajax = parseInt(ICOfield.val());

    // vytahneme data z aresu
    $.ajax({
        url: ABSOLUTE_URL + "plugins/eshop/classes/ares.php",
        type: "POST",
        dataType: "JSON",
        data: {
            ico_ajax_send: ico_ajax,
            use_vies: true,
        },
        success: function (data) {

            //dosadime tam kam potrebujeme
            if(typeof data.ares != 'undefined' && data.success) {
                jmeno.val(data.ares.ares_firma_fin);
                //ulice.val(data.ares.ares_ulice_fin);
                //mesto.val(data.ares.ares_mesto_fin);
                //psc.val(data.ares.ares_psc_fin);
                //dic.val(data.ares.ares_dic_fin);

            }else{
                if('ares' in data) {
                    FastMessage.createMessage(data.ares, FastMessage.error);
                }
            }
        }
    });
});